import {
  getOrganizationsQuery,
  createOrganizationMutation,
  deleteOrganizationMutation,
  updateOrganizationMutation,
  getUsersInOrganizationQuery,
  deleteUserOrganizationByIdMutation
} from '~graphql/organizations.graphql'

export default {
  getAllOrganizations({ state, dispatch }) {
    return dispatch('getItems', {
      state,
      loader: 'organizations:get',
      modelName: 'organizations',
      query: getOrganizationsQuery,
      resultPath: 'organizations.nodes'
    })
  },
  getOrganizationUsers({ state, dispatch }, organizationId) {
    return dispatch('getItems', {
      state,
      variables: { organizationId },
      loader: 'organizationUsers:get',
      modelName: 'organizationUsers',
      query: getUsersInOrganizationQuery,
      resultPath: 'userOrganizations.nodes'
    })
  },
  deleteOrganizationUser({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      removeFrom: ['organizationUsers'],
      loader: 'organizationUser:delete',
      mutation: deleteUserOrganizationByIdMutation
    })
  },
  createOrganization({ state, dispatch }, organization) {
    return dispatch('createItem', {
      item: { organization },
      state,
      loader: 'organization:create',
      addTo: ['organizations'],
      mutation: createOrganizationMutation,
      resultPath: 'createOrganization.organization'
    })
  },
  updateOrganization({ state, dispatch }, payload) {
    return dispatch('updateItem', {
      item: payload,
      state,
      modelName: 'selectedOrganization',
      addTo: ['organizations'],
      loader: 'organization:update',
      mutation: updateOrganizationMutation,
      resultPath: 'updateOrganization.organization'
    })
  },
  deleteOrganization({ state, dispatch }, id) {
    return dispatch('deleteItem', {
      id,
      state,
      modelName: 'selectedOrganization',
      removeFrom: ['organizations'],
      loader: 'organization:delete',
      mutation: deleteOrganizationMutation
    })
  },
  setSelectedOrganization({ state, commit }, selectedOrganization) {
    commit('SET_ITEM', {
      state,
      item: selectedOrganization,
      modelName: 'selectedOrganization'
    })
  }
}
